import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable()
export class LcpApiService {
  constructor(private http: HttpClient) {}

  authenticateCognito(token: string): Promise<{ idToken; accessToken; refreshToken }> {
    return this.http
      .get<any>(`${environment.lcpApiUrl}/cognito/tokens`, {
        headers: {
          Client: 'Pathfinder',
          Authorization: `Bearer ${token}`
        }
      })
      .toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/lcp-api.service.ts